import pdfMake from 'pdfmake/build/pdfmake';
import vfsFonts from 'pdfmake/build/vfs_fonts';
import urlBase from '../../url-base';
import moment from 'moment';


export default (dados, tipo) => {

	const { vfs } = vfsFonts.pdfMake;
	pdfMake.vfs = vfs;

    if (dados.status === "AGUARDANDO PAGAMENTO") {
		dados.status = "AGUARDANDO CONFIRMAÇÃO";
	}
	
	let empresa = dados;
	let tributacao;
	switch (empresa.tipoTributacao) {
		case "1":
			tributacao = "Não Optante";
		break;
		case "2":
			tributacao = "Lucro Real";
		break;
		case "3":
			tributacao = "Lucro Resumido";
		break;
		case "4":
			tributacao = "Simples Nacional";
		break;
	}	
	/**
	 * EMPRESA CONTRATANTE
	 * @returns 
	 */
	function empresaContratante() {
		let body = [];
		let dataRow = [];
		let dataAbertura = moment(empresa.openingDate).format('DD/MM/YYYY');

		// DEFINIR DADOS DA EMPRESA CONTRATANTE
		dataRow.push({ text: "EMPRESA CONTRATANTE", colSpan: 3, style: 'styleTitulo' }, {}, {});
		body.push(dataRow);
		dataRow = [];
		dataRow.push({ text: "CNPJ", style: 'styleCampo' }, { text: "DATA DE ABERTURA", style: 'styleCampo' }, { text: "NOME FANTASIA", style: 'styleCampo' });
		body.push(dataRow);
		dataRow = [];
		dataRow.push({ text: empresa.cnpj, style: 'styleDados' }, { text: dataAbertura, style: 'styleDados' }, { text: empresa.fantasyName, style: 'styleDados' });
		body.push(dataRow);
		dataRow = [];
		dataRow.push({ text: "NOME EMPRESARIAL", colSpan: 2, style: 'styleCampo' }, {}, {});
		body.push(dataRow);
		dataRow = [];
		dataRow.push({ text: empresa.businessName, colSpan: 2, style: 'styleDados' }, {}, {});
		body.push(dataRow);
		dataRow = [];
		dataRow.push({ text: "TIPO DE TRIBUTAÇÃO", colSpan: 2, style: 'styleCampo' }, {}, {});
		body.push(dataRow);
		dataRow = [];
		dataRow.push({ text: tributacao, colSpan: 2, style: 'styleDados' }, {}, {});
		body.push(dataRow);
		return body;
	}
	/**
	 * Endereço
	 * @returns 
	 */
	function Endereco() {
		let body = [];
		let dataRow = [];
		let complemento = (empresa.addressComplement == '' ? 'NÃO INFORMADO' : empresa.addressComplement);
		dataRow.push({ text: "ENDEREÇO", colSpan: 4, style: 'styleTitulo' }, {}, {}, {});
		body.push(dataRow);
		dataRow = [];
		dataRow.push({ text: "RUA", style: 'styleCampo' }, { text: "BAIRRO", style: 'styleCampo' }, { text: "CIDADE", style: 'styleCampo' }, { text: "UF", style: 'styleCampo' });
		body.push(dataRow);
		dataRow = [];
		dataRow.push({ text: empresa.address, style: 'styleDados' }, { text: empresa.bairro, style: 'styleDados' }, { text: empresa.municipio, style: 'styleDados' }, { text: empresa.estado, style: 'styleDados' });
		body.push(dataRow);
		dataRow = [];
		dataRow.push({ text: "CEP", style: 'styleCampo' }, { text: "COMPLEMENTO", style: 'styleCampo' }, { text: "NÚMERO", colSpan: 2, style: 'styleCampo' }, {});
		body.push(dataRow);
		dataRow = [];
		dataRow.push({ text: empresa.cep, style: 'styleDados' }, { text: complemento, style: 'styleDados' }, { text: empresa.addressNumber, colSpan: 2, style: 'styleDados' }, {});
		body.push(dataRow);
		return body;
	}




	function Telefones() {

		let body = [];
		let dataRow = [];
		dataRow = [];
		dataRow.push({ text: "TELEFONES", colSpan: 3, style: 'styleTitulo' }, {}, {});
		body.push(dataRow);
		dataRow = [];
		dataRow.push({ text: "TELEFONE FIXO", style: 'styleCampo' }, { text: "CELULAR 1", style: 'styleCampo' }, { text: "CELULAR 2", style: 'styleCampo' });
		body.push(dataRow);
		dataRow = [];
		dataRow.push({ text: dados.homePhone, style: 'styleDados' }, { text: dados.cellPhone, style: 'styleDados' }, { text: dados.cellPhone2, style: 'styleDados' });
		body.push(dataRow);

		return body;
	}

	function ResponsavelLegal() {

		let body = [];
		let dataRow = [];
		dataRow = [];
		dataRow.push({ text: "RESPONSÁVEL LEGAL", colSpan: 3, style: 'styleTitulo' }, {}, {});
		body.push(dataRow);
		dataRow = [];
		dataRow.push({ text: "NOME COMPLETO", style: 'styleCampo' }, { text: "RG", style: 'styleCampo' }, { text: "CPF", style: 'styleCampo' });
		body.push(dataRow);
		dataRow = [];
		dataRow.push({ text: dados.legalResponsible, style: 'styleDados' }, { text: dados.legalResponsibleRg, style: 'styleDados' }, { text: dados.legalResponsibleCpf, style: 'styleDados' });
		body.push(dataRow);

		return body;
	}

	function Documentos() {
		let documentos = dados.imagesDoc;
		let body = [];
		let dataRow = [];

		let cpf = (documentos.cpf == '' ? 'NÃO ENVIADO' : 'EM ANEXO');
		let rg = (documentos.rg == '' ? 'NÃO ENVIADO' : 'EM ANEXO');
		let rg2 = (documentos.rg2 == '' ? 'NÃO ENVIADO' : 'EM ANEXO');
		let cnh = (documentos.cnh == '' ? 'NÃO ENVIADO' : 'EM ANEXO');
		let cnpj = (documentos.cnpj == '' ? 'NÃO ENVIADO' : 'EM ANEXO');
		let propostaFisica = (documentos.physicalContract == '' ? 'NÃO ENVIADO' : 'EM ANEXO');

		dataRow = [];
		dataRow.push({ text: "DOCUMENTOS", colSpan: 3, style: 'styleTitulo' }, {}, {});
		body.push(dataRow);
		dataRow = [];
		dataRow.push({ text: "CPF", style: 'styleCampo' }, { text: "RG", style: 'styleCampo' }, { text: "RG REVERSO", style: 'styleCampo' });
		body.push(dataRow);
		dataRow = [];
		dataRow.push({ text: cpf, style: 'styleDados' }, { text: rg, style: 'styleDados' }, { text: rg2, style: 'styleDados' });
		body.push(dataRow);
		dataRow = [];
		dataRow.push({ text: "CNH", style: 'styleCampo' }, { text: "CNPJ", style: 'styleCampo' }, { text: "PROPOSTA FÍSICA", style: 'styleCampo' });
		body.push(dataRow);
		dataRow = [];
		dataRow.push({ text: cnh, style: 'styleDados' }, { text: cnpj, style: 'styleDados' }, { text: propostaFisica, style: 'styleDados' });
		body.push(dataRow);
		return body;
	}

	function GestaoContratos() {

		let encarregado = (dados.infoPersonInCharge == '' ? 'NÃO INFORMADO' : dados.infoPersonInCharge);
		let emailContato = (dados.infoEmailContact == '' ? 'NÃO INFORMADO' : dados.infoEmailContact);
		let emailFatura = (dados.infoEmailInvoice == '' ? 'NÃO INFORMADO' : dados.infoEmailInvoice);
		let body = [];
		let dataRow = [];

		dataRow.push({ text: "GESTÃO DE CONTRATOS", colSpan: 3, style: 'styleTitulo' }, {}, {});
		body.push(dataRow);
		dataRow = [];
		dataRow.push({ text: "ENCARREGADO", colSpan: 3, style: 'styleCampo' }, {}, {});
		body.push(dataRow);
		dataRow = [];
		dataRow.push({ text: encarregado, colSpan: 3, style: 'styleDados' }, {}, {});
		body.push(dataRow);
		dataRow = [];
		dataRow.push({ text: "E-MAIL CONTATO", style: 'styleCampo' }, { text: "E-MAIL PARA FATURA", colSpan: 2, style: 'styleCampo' }, {});
		body.push(dataRow);

		dataRow = [];
		dataRow.push({ text: emailContato, style: 'styleDados' }, { text: emailFatura, colSpan: 2, style: 'styleDados' }, {});
		body.push(dataRow);
		
		dataRow = [];
		dataRow.push({ text: "TELEFONE FIXO", style: 'styleCampo' }, { text: "CELULAR 1", colSpan: 2, style: 'styleCampo' }, {});
		body.push(dataRow);
		dataRow = [];
		dataRow.push({ text: dados.infoHomePhone, style: 'styleDados' }, { text: dados.infoCellPhone, style: 'styleDados' }, { });
		body.push(dataRow);		
		return body;
	}

	function QuantidadeUsuarios() {

		let body = [];
		let dataRow = [];
		let valorTitular = (dados.valuePlanHolder == '' ? 'NÃO INFORMADO' : dados.valuePlanHolder);
		let valorDependente = (dados.valuePlanDependent == '' ? 'NÃO INFORMADO' : dados.valuePlanDependent);
		let clinicoDependente = (dados.amountDependent == '' ? 'NÃO INFORMADO' : dados.amountDependent);
		let clinicoOrto = (dados.amountOrto == '' ? 'NÃO INFORMADO' : dados.amountOrto);
		let valorOrto = (dados.valuePlanOrto == '' ? 'NÃO INFORMADO' : dados.valuePlanOrto);

		dataRow.push({ text: "QUANTIDADE DE USUÁRIOS", colSpan: 2, style: 'styleTitulo' }, {});
		body.push(dataRow);
		dataRow = [];
		dataRow.push({ text: "CLÍNICO TITULAR", style: 'styleCampo' }, { text: "VALOR TITULAR", style: 'styleCampo' });
		body.push(dataRow);
		dataRow = [];
		dataRow.push({ text: dados.amountHolder, style: 'styleDados' }, { text: valorTitular, style: 'styleDados' });
		body.push(dataRow);
		dataRow = [];
		dataRow.push({ text: "CLÍNICO DEPENDENTE", style: 'styleCampo' }, { text: "VALOR DEPENDENTE", style: 'styleCampo' });
		body.push(dataRow);
		dataRow = [];
		dataRow.push({ text: clinicoDependente, style: 'styleDados' }, { text: valorDependente, style: 'styleDados' });
		body.push(dataRow);
		dataRow = [];
		dataRow.push({ text: "ORTO (TITULAR/DEPENDENTE)", style: 'styleCampo' }, { text: "VALOR ORTO", style: 'styleCampo' });
		body.push(dataRow);
		dataRow = [];
		dataRow.push({ text: clinicoOrto, style: 'styleDados' }, { text: valorOrto, style: 'styleDados' });
		body.push(dataRow);

		dataRow = [];
		dataRow.push({ text: "TIPO DE PLANO CLÍNICO", style: 'styleCampo' }, { text: "TIPO DE PLANO ORTO", style: 'styleCampo' });
		body.push(dataRow);
		dataRow = [];
		dataRow.push({ text: dados.plano, style: 'styleDados' }, { text: "", style: 'styleDados' });
		body.push(dataRow);

		dataRow = [];
		dataRow.push({ text: "PLANILHA COM RELAÇÃO DE USUÁRIOS", colSpan: 2, style: 'styleCampo' }, {});
		body.push(dataRow);
		dataRow = [];
		dataRow.push({ text: "CLIQUE AQUI PARA VISUALIZAR", link: "https://planodentalcenter.com.br/api/attachments/docs/download/{{$imagesDoc['usersTable']}}", style: 'styleDados' }, {});
		body.push(dataRow);

		return body;
	}

	function InformacoesContratuais() {

		let body = [];
		let dataRow = [];
		dataRow = [];
		dataRow.push({ text: "INFORMAÇÕES CONTRATUAIS", colSpan: 2, style: 'styleTitulo' }, {});
		body.push(dataRow);
		dataRow = [];
		dataRow.push({ text: "REGISTRO NA ANS", style: 'styleCampo' }, { text: "TIPO DE SEGMENTAÇÃO", style: 'styleCampo' });
		body.push(dataRow);
		dataRow = [];
		dataRow.push({ text: "471.616/14-7", style: 'styleDados' }, { text: "ODONTOLOGIA", style: 'styleDados' });
		body.push(dataRow);
		dataRow = [];
		dataRow.push({ text: "TIPO DE VÍNCULO DO BENEFICIÁRIO", style: 'styleCampo' }, { text: "ABRANGÊNCIA GEOGRÁFICA", style: 'styleCampo' });
		body.push(dataRow);
		dataRow = [];
		dataRow.push({ text: "EMPREGATÍCIO", style: 'styleDados' }, { text: "GRUPO DE MUNICÍPIOS", style: 'styleDados' });
		body.push(dataRow);
		return body;
	}

	function DatasPrazos() {
		let dataAdesao = dados.effectiveDate + '/' + dados.effectiveDateMonth + '/' + dados.effectiveDateYear;
		let centroCusto = '';
		let carenciaCobertura = '';

		switch (dados.costCenterS4) {
			case 1:
				centroCusto = 'JOAO PESSOA';
				break;
			case 2:
				centroCusto = 'CAMPINA GRANDE';
				break;
			case 3:
				centroCusto = 'GUARABIRA';
				break;
			default:
				centroCusto = 'SÃO LUIZ';
		}
		switch (dados.carenciaCoberturaS4) {
			case 0:
				carenciaCobertura = 'SEM CARÊNCIA';
				break;
			case 1:
				carenciaCobertura = 'PADRÃO DO PLANO DO USUÁRIO';
				break;
		}

		let vigencia = (dados.effectiveDate == '' ? 'NÃO INFORMADO' : dados.effectiveDate);
		let body = [];
		let dataRow = [];

		dataRow.push({ text: "DATAS E PRAZOS", colSpan: 3, style: 'styleTitulo' }, {}, {});
		body.push(dataRow);
		dataRow = [];
		dataRow.push({ text: "DATA DE ADESÃO", style: 'styleCampo' }, { text: "CENTRO DE CUSTO", style: 'styleCampo' }, { text: "DIA VIGẼNCIA", style: 'styleCampo' });
		body.push(dataRow);
		dataRow = [];
		dataRow.push({ text: dataAdesao, style: 'styleDados' }, { text: centroCusto, style: 'styleDados' }, { text: vigencia, style: 'styleDados' });
		body.push(dataRow);
		dataRow = [];
		dataRow.push({ text: "CARÊNCIA COBERTURA", colSpan: 3, style: 'styleCampo' }, {}, {});
		body.push(dataRow);
		dataRow = [];
		dataRow.push({ text: carenciaCobertura, colSpan: 3, style: 'styleDados' }, {}, {});
		body.push(dataRow);
		return body;
	}

	function Cobertura() {

		let body = [];
		let dataRow = [];
        let carenciaDentistica = "30 DIAS";
		let carenciaPeriodontia = "90 DIAS";
		let carenciaCirurgia = "120 DIAS";

		if ((dados.amountHolder + dados.amountDependent + dados.amountOrto) >= 30) {
			carenciaDentistica = "24 HORAS";
			carenciaPeriodontia = "24 HORAS";
			carenciaCirurgia = "24 HORAS";
		}
		dataRow = [];
		dataRow.push({ text: "CORBETURAS", style: 'styleCarenciaTitulo' }, { text: "BOLETO BANCÁRIO", style: 'styleCarenciaTitulo' });
		body.push(dataRow);
		dataRow = [];
		dataRow.push({ text: "URGÊNCIA/EMERGÊNCIA", style: 'styleCarenciaDados1' }, { text: "24 HORAS", style: 'styleCarenciaDados2' });
		body.push(dataRow);
		dataRow = [];
		dataRow.push({ text: "DENTÍSTICA, RADIOLOGIA, DIAGNÓSTICO E ODONTOLOGIA PREVENTIVA", style: 'styleCarenciaDados1' }, { text: carenciaDentistica, style: 'styleCarenciaDados2' });
		body.push(dataRow);
		dataRow = [];
		dataRow.push({ text: "PERIODONTIA E ENDODONTIA", style: 'styleCarenciaDados1' }, { text: carenciaPeriodontia, style: 'styleCarenciaDados2' });
		body.push(dataRow);
		dataRow = [];
		dataRow.push({ text: "CIRURGIAS", style: 'styleCarenciaDados1' }, { text: carenciaCirurgia, style: 'styleCarenciaDados2' });
		body.push(dataRow);
		return body;
	}
	function tableEmpresaContratante() {
		return {
			style: 'tableEstilo',
			table: {
				widths: ['*', '*', '*'],
				heights: [20, 0, 20, 0, 20, 0],
				headerRows: 0,
				body: empresaContratante(),
			},
			layout: 'noBorders',


		};
	}
	function tableEndereco() {
		return {
			style: 'tableEstilo',
			table: {
				widths: ['*', 150, 80, 80],
				heights: [20, 0, 20, 0, 20, 0],
				headerRows: 0,
				body: Endereco(),
			},
			layout: 'noBorders',
		};
	}

	function tableTelefones() {
		return {
			style: 'tableEstilo',
			table: {
				widths: ['*', '*', '*'],
				heights: [20, 0, 20, 0],
				headerRows: 0,
				body: Telefones()
			},
			layout: 'noBorders',
		};
	}
	function tableResponsavelLegal() {
		return {
			style: 'tableEstilo',
			table: {
				widths: ['*', '*', '*'],
				heights: [20, 0, 20, 0],
				headerRows: 0,
				body: ResponsavelLegal()
			},
			layout: 'noBorders',
		};
	}
	function tableDocumentos() {
		return {
			style: 'tableEstilo',
			table: {
				widths: ['*', '*', '*'],
				heights: [20, 0, 20, 0],
				headerRows: 0,
				body: Documentos()
			},
			layout: 'noBorders',
		};
	}
	function tableGestaoContratos() {
		return {
			style: 'tableEstilo',
			table: {
				widths: [250, 250, 0],
				heights: [20, 0, 20, 0, 20, 0],
				headerRows: 0,
				body: GestaoContratos()
			},
			layout: 'noBorders',
		};
	}

	function tableQuantidadeUsuarios() {
		return {
			style: 'tableEstilo',
			table: {
				widths: ['*', '*'],
				heights: [20, 0, 20, 0, 20, 0, 20, 0, 20, 0],
				headerRows: 0,
				body: QuantidadeUsuarios()
			},
			layout: 'noBorders',
		};
	}
	function tableInformacoesContratuais() {
		return {
			style: 'tableEstilo',
			table: {
				widths: ['*', '*'],
				heights: [20, 0, 20, 0],
				headerRows: 0,
				body: InformacoesContratuais()
			},
			layout: 'noBorders',
		};
	}
	function tableDadosPrazos() {
		return {
			style: 'tableEstilo',
			table: {
				widths: ['*', '*', '*'],
				heights: [20, 0, 20, 0],
				headerRows: 0,
				body: DatasPrazos()
			},
			layout: 'noBorders',
		};
	}
	function tableCobertura() {
		return {
			style: 'tableEstilo',
			table: {
				widths: [300, 200],
				heights: [15, 30, 30, 30, 30, 30, 30],
				headerRows: 0,
				body: Cobertura()
			},
			layout: 'noBorders',
		};
	}
	const documentDefinition = {
		// Definição da Página
		pageSize: 'A4',
		pageOrientation: 'portrait',
		pageMargins: [40, 100, 40, 60],
		header: function () {
			return [
				{
					alignment: 'justify',
					columns: [
						{ image: 'logo_dental', width: 150, style: 'logo' },
						{
							stack: [
								{ text: 'RESUMO DA PROPOSTA PJ ', style: 'header' },
								{ text: "STATUS : " + dados.status, style: 'subheader' },

							],

						}
					]

				},
			];
		},

		footer(currentPage, pageCount) {
			return {
				layout: 'noBorders',
				margin: [40, 20, 40, 22],
				table: {
					widths: ['auto'],
					body: [
						[
							{
								text:
									'___________________________________________________________________________________________________________________________________________________________________________________________________________________________________',
								alignment: 'center',
								fontSize: 5,
							},
						],
						[
							[
								{
									text: `Página ${currentPage.toString()} de ${pageCount}`,
									fontSize: 8,
									alignment: 'right',
									/* horizontal, vertical */
									margin: [3, 0],
								},

							],
						],
					],
				},
			};
		},

		content: [
			{
				text:
					'___________________________________________________________________________________________________________________________________________________________________________________________________________________________________',
				alignment: 'center',
				fontSize: 5,
			},
			tableEmpresaContratante(),
			{
				text:
					'___________________________________________________________________________________________________________________________________________________________________________________________________________________________________',
				alignment: 'center',
				fontSize: 5,
			},
			tableEndereco(),
			{
				text:
					'___________________________________________________________________________________________________________________________________________________________________________________________________________________________________',
				alignment: 'center',
				fontSize: 5,
			},
			tableTelefones(),
			{
				text:
					'___________________________________________________________________________________________________________________________________________________________________________________________________________________________________',
				alignment: 'center',
				fontSize: 5,
			},
			tableResponsavelLegal(),
			{
				text:
					'___________________________________________________________________________________________________________________________________________________________________________________________________________________________________',
				alignment: 'center',
				fontSize: 5,
			},
			tableDocumentos(),
			{
				text:
					'___________________________________________________________________________________________________________________________________________________________________________________________________________________________________',
				alignment: 'center',
				fontSize: 5,
			},
			tableGestaoContratos(),
			{
				text:
					'___________________________________________________________________________________________________________________________________________________________________________________________________________________________________',
				alignment: 'center',
				fontSize: 5,
			},
			tableQuantidadeUsuarios(),
			{
				text:
					'___________________________________________________________________________________________________________________________________________________________________________________________________________________________________',
				alignment: 'center',
				fontSize: 5,
			},
			tableInformacoesContratuais(),
			{
				text:
					'___________________________________________________________________________________________________________________________________________________________________________________________________________________________________',
				alignment: 'center',
				fontSize: 5,
			},
			tableDadosPrazos(),
			{
				text:
					'___________________________________________________________________________________________________________________________________________________________________________________________________________________________________',
				alignment: 'center',
				fontSize: 5,
			},
			tableCobertura(),
		],

		images: {
			mySuperImage: 'data:image/jpeg;base64,...content...',

			// in browser is supported loading images via url (https or http protocol) (minimal version: 0.1.67)
			snow: 'https://picsum.photos/seed/picsum/200/300',

			// is supported loding images via url with custom headers (minimal version: 0.2.5)
			logo_dental: {
				url: urlBase.client + 'assets/images2/new_layout/logo_dental.png'
				/* 			  headers: {
				
								myheader: '123',
								myotherheader: 'abc',
							  } */
			}
		},


		// Definição dos estilos
		styles: {
			// margin: [left, top, right, bottom]
			header: {
				fontSize: 16,
				bold: true,
				alignment: 'left',
				margin: [80, 40, 40, 0],
				color: '#d51125',

			},
			footer: {
				fontSize: 12,
				bold: false,
				alignment: 'right',
				margin: [0, 23, 40, 0]

			},
			subheader: {
				fontSize: 14,
				bold: true,
				alignment: 'left',
				margin: [80, 0, 40, 0],
				color: '#696969',

			},
			tableHeader: {
				fontSize: 12,
				italics: false,
				bold: true,
				color: '#000000',
				fillColor: '#aeaaa9'

			},
			logo: {
				alignment: 'left',
				margin: [40, 20, 0, 0]

			},

			styleTitulo: {
				fontSize: 12,
				bold: false,
				alignment: 'center',
				color: '#696969',
				border: [false, false, false, false],
				//fillColor: '#808080'
			},
			styleCampo: {
				fontSize: 10,
				bold: true,
				alignment: 'left',
				color: '#d31a25',
				border: [true, true, true, true]
				//fillColor: '#808080'
			},
			styleDados: {
				fontSize: 9,
				bold: false,
				alignment: 'left',
				color: '#696969',
				border: [true, true, true, true],
				//fillColor: '#808080'
			},
			styleCarenciaTitulo: {
				fontSize: 10,
				bold: true,
				alignment: 'center',
				color: '#ffffff',
				fillColor: '#d31a25'
			},
			styleCarenciaDados1: {
				fontSize: 10,
				bold: true,
				alignment: 'center',
				color: '#d31a25',
				fillColor: '#EEEDEB'
			},
			styleCarenciaDados2: {
				fontSize: 10,
				bold: true,
				alignment: 'center',
				color: '#d31a25',
				fillColor: '#E3E0DD'
			},
			tableEstilo: {
				fontSize: 10,
				margin: [0, 5, 0, 15],
				border: [false, false, false, false],
				borderColor: ['#ff00ff', '#00ffff', '#ff00ff', '#00ffff']
			},
			styleSemDados: {
				fontSize: 10,
				bold: true,
				alignment: 'center',
				color: '#d31a25',
				border: [true, true, true, true]
				//fillColor: '#808080'
			},
		},

	};

	if (tipo == 'download') {
		pdfMake.createPdf(documentDefinition).download('resumo-proposta-pj.pdf');
	}
	else {
		pdfMake.createPdf(documentDefinition).open();
	}


};



/** WEBPACK FOOTER **
 ** ./src/components/relatorio/resumo_proposta_pj.js
 **/